export default {
  group: 'form-group',
  label: 'label-override',
  displayWrapper: '',
  text: 'form-control',
}



// WEBPACK FOOTER //
// src/common/form-elements/simple-text-element-folder/simple-text-element.style.js